// src/pages/HomePage.jsx

import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Helmet } from 'react-helmet-async';
import {
  Container,
  Box,
  Typography,
  TextField,
  InputAdornment,
  Button,
  Grid,
  Paper,
  Stack,
  Chip,
  Alert,
  CircularProgress,
  useTheme,
  useMediaQuery,
  Pagination,
  Card,
  CardContent,
  CardMedia,
  Avatar,
  Rating,
  Divider,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Slider,
  Tabs,
  Tab,
  Badge,
  Fade,
  Zoom,
  Slide,
  Grow,
  Fab,
  Tooltip,
  Skeleton,
  useScrollTrigger,
  AppBar,
  Toolbar,
  Switch,
  FormControlLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  LinearProgress,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  InputBase,
  Backdrop,
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
  Breadcrumbs,
  Link as MuiLink,
  Collapse,
  AlertTitle,
  ToggleButton,
  ToggleButtonGroup,
  CardActionArea,
  CardActions,
  CardHeader,
  ListItemButton,
  ListItemAvatar,
  Chip as MuiChip,
  Box as MuiBox,
  Typography as MuiTypography,
} from '@mui/material';
import {
  Search,
  LocationOn,
  FilterList,
  Star,
  Language,
  AccessTime,
  Verified,
  NavigateNext,
  CalendarToday,
  Psychology,
  LocalHospital,
  School,
  Translate,
  VideoCall,
  Phone,
  Person,
  Work,
  Payment,
  Schedule,
  People,
  TrendingUp,
  TrendingDown,
  CheckCircle,
  Cancel,
  Info,
  Warning,
  Error,
  Help,
  Close,
  KeyboardArrowDown,
  KeyboardArrowUp,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  FirstPage,
  LastPage,
  NavigateBefore,
  MoreVert,
  MoreHoriz,
  FilterAlt,
  Sort,
  ViewList,
  ViewModule,
  GridView,
  List as ListIcon,
  Map,
  MyLocation,
  GpsFixed,
  GpsOff,
  Notifications,
  NotificationsOff,
  Settings,
  Support,
  Chat,
  Receipt,
  Folder,
  Today,
  ViewWeek,
  Add,
  Remove,
  Clear,
  Done,
  Edit,
  Delete,
  Save,
  Download,
  Upload,
  Print,
  Send,
  Reply,
  Forward,
  Archive,
  Unarchive,
  MarkEmailRead,
  MarkEmailUnread,
  Drafts,
  Inbox,
  Outbox,
  Sent,
  Trash,
  Spam,
  Label,
  FolderOpen,
  FolderSpecial,
  Cloud,
  CloudUpload,
  CloudDownload,
  CloudSync,
  CloudOff,
  Wifi,
  WifiOff,
  SignalCellular4Bar,
  SignalCellularConnectedNoInternet4Bar,
  SignalCellularNoSim,
  SignalCellularNull,
  SignalCellularOff,
  SignalWifi4Bar,
  SignalWifiConnectedNoInternet4Bar,
  SignalWifiOff,
  SignalWifiStatusbar4Bar,
  SignalWifiStatusbarConnectedNoInternet4Bar,
  SignalWifiStatusbarNull,
  Battery20,
  Battery30,
  Battery50,
  Battery60,
  Battery80,
  Battery90,
  BatteryFull,
  BatteryChargingFull,
  BatteryStd,
  BatteryUnknown,
  Brightness4,
  Brightness5,
  Brightness6,
  Brightness7,
  BrightnessAuto,
  BrightnessHigh,
  BrightnessLow,
  BrightnessMedium,
  ScreenRotation,
  ScreenShare,
  StopScreenShare,
  Cast,
  CastConnected,
  CastForEducation,
  Computer,
  DesktopMac,
  DesktopWindows,
  DeveloperBoard,
  DeviceHub,
  Devices,
  Dock,
  Gamepad,
  Headset,
  HeadsetMic,
  Keyboard,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowLeft as KeyboardArrowLeftIcon,
  KeyboardArrowRight as KeyboardArrowRightIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
  KeyboardBackspace,
  KeyboardCapslock,
  KeyboardHide,
  KeyboardReturn,
  KeyboardTab,
  KeyboardVoice,
  Laptop,
  LaptopChromebook,
  LaptopMac,
  LaptopWindows,
  Memory,
  Mouse,
  PhoneAndroid,
  PhoneIphone,
  Phonelink,
  PhonelinkOff,
  Router,
  Scanner,
  Security,
  SimCard,
  Smartphone,
  Speaker,
  SpeakerGroup,
  Tablet,
  TabletAndroid,
  TabletMac,
  Toys,
  Tv,
  VideogameAsset,
  Watch,
  WatchLater,
  AccessTimeFilled,
  Accessible,
  AccessibleForward,
  AccountBalance,
  AccountBalanceWallet,
  AccountBox,
  AccountCircle,
  AddShoppingCart,
  Alarm,
  AlarmAdd,
  AlarmOff,
  AlarmOn,
  AllInbox,
  AllOut,
  Android,
  Announcement,
  AspectRatio,
  Assessment,
  Assignment,
  AssignmentInd,
  AssignmentLate,
  AssignmentReturn,
  AssignmentReturned,
  AssignmentTurnedIn,
  Autorenew,
  Backup,
  Book,
  BookOnline,
  Bookmark,
  BookmarkBorder,
  BugReport,
  Build,
  Cached,
  CameraEnhance,
  CardGiftcard,
  CardMembership,
  CardTravel,
  ChangeHistory,
  ChromeReaderMode,
  Class,
  Code,
  Commute,
  CompareArrows,
  ContactSupport,
  Copyright,
  CreditCard,
  Dashboard,
  Description,
  Dns,
  DoneAll,
  DonutLarge,
  DonutSmall,
  DragIndicator,
  Eco,
  EuroSymbol,
  Event,
  EventSeat,
  ExitToApp,
  Explore,
  Extension,
  Face,
  Favorite,
  FavoriteBorder,
  Feedback,
  FindInPage,
  FindReplace,
  Fingerprint,
  FlightLand,
  FlightTakeoff,
  FlipToBack,
  FlipToFront,
  GTranslate,
  Gavel,
  GetApp,
  Gif,
  Grade,
  GroupWork,
  HelpOutline,
  HighlightOff,
  History,
  Home,
  HorizontalSplit,
  HourglassEmpty,
  HourglassFull,
  Http,
  Https,
  ImportantDevices,
  InfoOutline,
  Input,
  InvertColors,
  LabelImportant,
  LabelOff,
  Launch,
  LineStyle,
  LineWeight,
  Lock,
  LockOpen,
  Loyalty,
  MarkunreadMailbox,
  Maximize,
  Minimize,
  Motorcycle,
  NoteAdd,
  OfflineBolt,
  OfflinePin,
  Opacity,
  OpenInBrowser,
  OpenInNew,
  OpenWith,
  Pageview,
  PanTool,
  PermCameraMic,
  PermContactCalendar,
  PermDataSetting,
  PermDeviceInformation,
  PermIdentity,
  PermMedia,
  PermPhoneMsg,
  PermScanWifi,
  Pets,
  PictureInPicture,
  PictureInPictureAlt,
  PlayForWork,
  Polymer,
  PowerSettingsNew,
  PregnantWoman,
  QueryBuilder,
  QuestionAnswer,
  RecordVoiceOver,
  Redeem,
  RemoveShoppingCart,
  Reorder,
  ReportProblem,
  Restore,
  RestoreFromTrash,
  RestorePage,
  Room,
  RoundedCorner,
  Rowing,
  SettingsApplications,
  SettingsBackupRestore,
  SettingsBluetooth,
  SettingsBrightness,
  SettingsCell,
  SettingsEthernet,
  SettingsInputAntenna,
  SettingsInputComponent,
  SettingsInputComposite,
  SettingsInputHdmi,
  SettingsInputSvideo,
  SettingsOverscan,
  SettingsPhone,
  SettingsPower,
  SettingsRemote,
  SettingsVoice,
  Shop,
  ShopTwo,
  ShoppingBasket,
  ShoppingCart,
  SpeakerNotes,
  SpeakerNotesOff,
  Spellcheck,
  StarRate,
  Stars,
  Store,
  Subject,
  SupervisedUserCircle,
  SupervisorAccount,
  SwapHoriz,
  SwapVert,
  SwapVerticalCircle,
  SystemUpdateAlt,
  TabUnselected,
  Theaters,
  ThreeDRotation,
  ThumbDown,
  ThumbUp,
  ThumbsUpDown,
  Timeline,
  Toc,
  Toll,
  TrackChanges,
  TurnedIn,
  TurnedInNot,
  Update,
  VerifiedUser,
  VerticalSplit,
  ViewAgenda,
  ViewArray,
  ViewCarousel,
  ViewColumn,
  ViewDay,
  ViewHeadline,
  ViewQuilt,
  ViewStream,
  Visibility,
  VisibilityOff,
  VoiceOverOff,
  WorkOff,
  WorkOutline,
  YoutubeSearchedFor,
  ZoomIn,
  ZoomOut,
  Refresh,
} from '@mui/icons-material';
import { styled, alpha } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import { motion, AnimatePresence } from 'framer-motion';
import debounce from 'lodash/debounce';
import { useNavigate, useLocation } from 'react-router-dom';

import FilterPanel from '../components/HomePage/FilterPanel';
import LocationSearch from '../components/HomePage/LocationSearch';
import DoctorCard from '../components/HomePage/DoctorCard';
import NoResults from '../components/HomePage/NoResults';
import DoctorsList from '../components/HomePage/DoctorsList';
import ErrorBoundary from '../components/ErrorBoundary';

import {
  fetchDoctors,
  updateFilters,
  setPage,
  clearFilters,
  selectDoctors,
  selectDoctorsCount,
  selectDoctorsLoading,
  selectDoctorsError,
  selectDoctorsFilters,
} from '../features/doctors/doctorsSlice';
import { fetchHomepageDataAsync, fetchLiveStatsAsync, incrementSearchCountAsync } from '../features/homepage/homepageSlice';
import {
  selectStats,
  selectTestimonials,
  selectFeatures,
  selectConfiguration,
  selectSearchSuggestions,
  selectLocations,
  selectSearchOptions,
  selectHomepageLoading,
  selectHomepageError,
} from '../features/homepage/homepageSlice';

// Enhanced Styled Components with modern design
const StyledHeroSection = styled(Box)(({ theme }) => ({
  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
  color: 'white',
  padding: theme.spacing(6, 2),
  borderRadius: theme.spacing(0, 0, 6, 6),
  marginBottom: theme.spacing(6),
  position: 'relative',
  overflow: 'hidden',
  minHeight: '70vh',
  display: 'flex',
  alignItems: 'center',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'radial-gradient(circle at 20% 80%, rgba(255,255,255,0.1) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(255,255,255,0.05) 0%, transparent 50%)',
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.03"%3E%3Ccircle cx="30" cy="30" r="2"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
  },
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(12, 4),
    minHeight: '80vh',
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(4, 2),
    minHeight: '60vh',
    borderRadius: theme.spacing(0, 0, 3, 3),
  },
}));

const StyledSearchBox = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: theme.spacing(4),
  boxShadow: '0 25px 80px rgba(0, 0, 0, 0.12), 0 8px 32px rgba(0, 0, 0, 0.08)',
  background: alpha(theme.palette.background.paper, 0.98),
  backdropFilter: 'blur(24px)',
  position: 'relative',
  zIndex: 1,
  border: `1px solid ${alpha(theme.palette.primary.main, 0.08)}`,
  transition: 'all 0.3s ease',
  '&:hover': {
    boxShadow: '0 32px 100px rgba(0, 0, 0, 0.15), 0 12px 40px rgba(0, 0, 0, 0.1)',
    transform: 'translateY(-2px)',
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3),
    borderRadius: theme.spacing(3),
    margin: theme.spacing(0, 1),
  },
}));

const StyledStatsCard = styled(Card)(({ theme }) => ({
  background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.08)} 0%, ${alpha(theme.palette.secondary.main, 0.08)} 100%)`,
  border: `1px solid ${alpha(theme.palette.primary.main, 0.12)}`,
  borderRadius: theme.spacing(3),
  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, transparent 50%)`,
    opacity: 0,
    transition: 'opacity 0.3s ease',
  },
  '&:hover': {
    transform: 'translateY(-6px) scale(1.02)',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.12), 0 8px 32px rgba(0, 0, 0, 0.08)',
    '&::before': {
      opacity: 1,
    },
  },
  [theme.breakpoints.down('sm')]: {
    borderRadius: theme.spacing(2),
  },
}));

const StyledTestimonialCard = styled(Card)(({ theme }) => ({
  background: theme.palette.background.paper,
  borderRadius: theme.spacing(3),
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
  transition: 'all 0.3s ease',
  border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 16px 48px rgba(0, 0, 0, 0.12)',
  },
}));

const StyledFeatureCard = styled(Card)(({ theme }) => ({
  background: `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${alpha(theme.palette.primary.main, 0.02)} 100%)`,
  borderRadius: theme.spacing(3),
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.06)',
  transition: 'all 0.3s ease',
  border: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
  },
}));

const StyledFloatingActionButton = styled(Fab)(({ theme }) => ({
  position: 'fixed',
  bottom: theme.spacing(3),
  right: theme.spacing(3),
  zIndex: 1000,
  background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
  color: 'white',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    background: `linear-gradient(135deg, ${theme.palette.primary.dark}, ${theme.palette.secondary.dark})`,
    transform: 'scale(1.1)',
    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.2)',
  },
  [theme.breakpoints.down('sm')]: {
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));

const HomePage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Homepage data from Redux
  const stats = useSelector(selectStats);
  const testimonials = useSelector(selectTestimonials);
  const features = useSelector(selectFeatures);
  const configuration = useSelector(selectConfiguration);
  const searchSuggestions = useSelector(selectSearchSuggestions);
  const locations = useSelector(selectLocations);
  const searchOptions = useSelector(selectSearchOptions);
  const homepageLoading = useSelector(selectHomepageLoading);
  const homepageError = useSelector(selectHomepageError);

  // Ensure we have valid stats data with fallbacks
  const validStats = useMemo(() => {
    if (!stats || Object.keys(stats).length === 0) {
      return {
        active_doctors: { value: '500+' },
        happy_patients: { value: '10K+' },
        cities_covered: { value: '50+' },
        success_rate: { value: '98%' }
      };
    }
    return stats;
  }, [stats]);

  // Optimized selectors for better performance
  const doctors = useSelector(selectDoctors);
  const count = useSelector(selectDoctorsCount);
  const loading = useSelector(selectDoctorsLoading);
  const error = useSelector(selectDoctorsError);
  const filters = useSelector(selectDoctorsFilters);



  // Optimistic UI: Show data immediately when it arrives, even if loading
  const displayDoctors = Array.isArray(doctors) ? doctors : [];
  const displayCount = count || 0;
  const isLoading = loading && displayDoctors.length === 0; // Only show loading if no data
  


  // Local state for enhanced features
  const [viewMode, setViewMode] = useState('grid');
  const [showFilters, setShowFilters] = useState(!isMobile);
  const [showStats, setShowStats] = useState(true);
  const [showTestimonials, setShowTestimonials] = useState(true);
  const [showFeatures, setShowFeatures] = useState(true);
  const [selectedSpecialties, setSelectedSpecialties] = useState([]);
  const [priceRange, setPriceRange] = useState([0, 5000]);
  const [experienceRange, setExperienceRange] = useState([0, 30]);
  const [availabilityFilter, setAvailabilityFilter] = useState('all');
  const [languageFilter, setLanguageFilter] = useState([]);
  const [genderFilter, setGenderFilter] = useState('all');
  const [consultationType, setConsultationType] = useState('all');
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [sortBy, setSortBy] = useState('newest');  // Changed from 'relevance' to 'newest'
  const [showMap, setShowMap] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [showDoctorModal, setShowDoctorModal] = useState(false);
  const [favorites, setFavorites] = useState([]);
  const [recentSearches, setRecentSearches] = useState([]);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  // Force refresh function for debugging
  const forceRefresh = useCallback(() => {
    console.log('Force refreshing doctors...');
    // Clear any existing data first
    dispatch(clearFilters());
    // Then fetch fresh data
    dispatch(fetchDoctors({ page: 1 }));
  }, [dispatch]);



  // Enhanced initial load with comprehensive retry mechanism
  useEffect(() => {
    console.log('Initial load - fetching homepage data and doctors...');
    
    const initializeData = async () => {
      try {
        // Fetch homepage data first
        await dispatch(fetchHomepageDataAsync()).unwrap();
        console.log('Homepage data loaded successfully');
      } catch (error) {
        console.error('Failed to load homepage data:', error);
      }
      
      // Fetch initial doctors with enhanced retry mechanism
      const fetchInitialDoctors = async () => {
        try {
          console.log('Fetching initial doctors...');
          await dispatch(fetchDoctors({ page: 1 })).unwrap();
          console.log('Initial doctors loaded successfully');
        } catch (error) {
          console.error('Failed to load initial doctors:', error);
          // Enhanced retry with exponential backoff
          let retryCount = 0;
          const maxRetries = 3;
          
          const retryWithBackoff = () => {
            if (retryCount < maxRetries) {
              retryCount++;
              const delay = Math.pow(2, retryCount) * 1000; // Exponential backoff: 2s, 4s, 8s
              console.log(`Retrying initial doctors fetch in ${delay}ms (attempt ${retryCount}/${maxRetries})...`);
              
              setTimeout(() => {
                dispatch(fetchDoctors({ page: 1 }))
                  .unwrap()
                  .then(() => {
                    console.log('Initial doctors loaded successfully on retry');
                  })
                  .catch((retryError) => {
                    console.error(`Retry ${retryCount} failed:`, retryError);
                    retryWithBackoff();
                  });
              }, delay);
            } else {
              console.error('All retry attempts failed for initial doctors fetch');
            }
          };
          
          retryWithBackoff();
        }
      };
      
      fetchInitialDoctors();
    };
    
    initializeData();
  }, [dispatch]);

  // Enhanced auto-retry mechanism with multiple fallback strategies
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!loading && (!displayDoctors || displayDoctors.length === 0) && !error) {
        console.log('No doctors loaded after 5 seconds, initiating fallback strategies...');
        
        // Strategy 1: Force refresh with current filters
        forceRefresh();
        
        // Strategy 2: If still no data after 3 more seconds, try without filters
        setTimeout(() => {
          if (!loading && (!displayDoctors || displayDoctors.length === 0) && !error) {
            console.log('Trying without filters as fallback...');
            dispatch(clearFilters());
            dispatch(fetchDoctors({ page: 1 }));
          }
        }, 3000);
        
        // Strategy 3: If still no data after 6 more seconds, try with minimal query
        setTimeout(() => {
          if (!loading && (!displayDoctors || displayDoctors.length === 0) && !error) {
            console.log('Trying with minimal query as last resort...');
            dispatch(fetchDoctors({ 
              page: 1, 
              query: '', 
              location: '', 
              speciality: '', 
              language: '',
              sortBy: 'newest'
            }));
          }
        }, 6000);
      }
    }, 5000);

    return () => clearTimeout(timer);
  }, [loading, displayDoctors, error, forceRefresh, dispatch]);

  // Optimized debounced search with shorter delay for better responsiveness
  const debouncedSearch = useMemo(
    () => debounce(newFilters => {
      console.log('Executing search with filters:', newFilters);
      dispatch(fetchDoctors(newFilters));
    }, 200), // Reduced from 300ms to 200ms for even snappier response
    [dispatch]
  );

  // Enhanced search change handler with better UX
  const handleSearchChange = useCallback((type, value) => {
    const newFilters = { ...filters, [type]: value, page: 1 }; // Reset to page 1 on new search
    dispatch(updateFilters({ [type]: value, page: 1 }));
    
    // For non-query filters, search immediately without debouncing
    if (type !== 'query') {
      console.log('Immediate search for filter:', type, value);
      dispatch(fetchDoctors(newFilters));
    } else if (value.trim().length >= 2) {
      // For query searches, use debouncing but with shorter delay
    debouncedSearch(newFilters);
    } else if (value.trim().length === 0) {
      // Clear search - fetch all doctors immediately
      console.log('Clearing search - fetching all doctors');
      dispatch(fetchDoctors({ ...newFilters, query: '' }));
    }
    
    // Add to recent searches
    if (type === 'query' && value.trim()) {
      const newSearch = { query: value.trim(), timestamp: Date.now() };
      setRecentSearches(prev => [newSearch, ...prev.filter(s => s.query !== value.trim()).slice(0, 4)]);
    }
  }, [filters, dispatch, debouncedSearch]);

  // Enhanced filter handlers with immediate feedback
  const handleFilterChange = useCallback((filterType, value) => {
    const newFilters = { ...filters, [filterType]: value, page: 1 };
    dispatch(updateFilters({ [filterType]: value, page: 1 }));
    console.log('Immediate filter change:', filterType, value);
    dispatch(fetchDoctors(newFilters)); // Immediate search
  }, [filters, dispatch]);

  // Handler for availability filter change
  const handleAvailabilityChange = useCallback((value) => {
    setAvailabilityFilter(value);
    const newFilters = { 
      ...filters, 
      availability: value !== 'all' ? value : undefined, 
      min_fee: priceRange[0] > 0 ? priceRange[0] : undefined,
      max_fee: priceRange[1] < 5000 ? priceRange[1] : undefined,
      min_experience: experienceRange[0] > 0 ? experienceRange[0] : undefined,
      page: 1 
    };
    dispatch(updateFilters({ availability: value !== 'all' ? value : undefined, page: 1 }));
    dispatch(fetchDoctors(newFilters));
  }, [filters, dispatch, priceRange, experienceRange]);

  // Handler for consultation type filter change
  const handleConsultationTypeChange = useCallback((value) => {
    setConsultationType(value);
    const newFilters = { 
      ...filters, 
      consultation_type: value !== 'all' ? value : undefined,
      min_fee: priceRange[0] > 0 ? priceRange[0] : undefined,
      max_fee: priceRange[1] < 5000 ? priceRange[1] : undefined,
      min_experience: experienceRange[0] > 0 ? experienceRange[0] : undefined,
      page: 1 
    };
    dispatch(updateFilters({ consultation_type: value !== 'all' ? value : undefined, page: 1 }));
    dispatch(fetchDoctors(newFilters));
  }, [filters, dispatch, priceRange, experienceRange]);

  // Handler for gender filter change
  const handleGenderChange = useCallback((value) => {
    setGenderFilter(value);
    const newFilters = { 
      ...filters, 
      gender: value !== 'all' ? value : undefined,
      min_fee: priceRange[0] > 0 ? priceRange[0] : undefined,
      max_fee: priceRange[1] < 5000 ? priceRange[1] : undefined,
      min_experience: experienceRange[0] > 0 ? experienceRange[0] : undefined,
      page: 1 
    };
    dispatch(updateFilters({ gender: value !== 'all' ? value : undefined, page: 1 }));
    dispatch(fetchDoctors(newFilters));
  }, [filters, dispatch, priceRange, experienceRange]);

  // Enhanced price range handler
  const handlePriceRangeChange = useCallback((newRange) => {
    setPriceRange(newRange);
    const newFilters = { 
      ...filters, 
      min_fee: newRange[0] > 0 ? newRange[0] : undefined,
      max_fee: newRange[1] < 5000 ? newRange[1] : undefined,
      min_experience: experienceRange[0] > 0 ? experienceRange[0] : undefined,
      max_experience: experienceRange[1] < 30 ? experienceRange[1] : undefined,
      availability: availabilityFilter !== 'all' ? availabilityFilter : undefined,
      consultation_type: consultationType !== 'all' ? consultationType : undefined,
      gender: genderFilter !== 'all' ? genderFilter : undefined,
      page: 1 
    };
    dispatch(updateFilters({ min_fee: newRange[0] > 0 ? newRange[0] : undefined, max_fee: newRange[1] < 5000 ? newRange[1] : undefined, page: 1 }));
    console.log('Price range change:', newRange);
    dispatch(fetchDoctors(newFilters)); // Immediate search
  }, [filters, dispatch, experienceRange, availabilityFilter, consultationType, genderFilter]);

  // Enhanced experience range handler
  const handleExperienceRangeChange = useCallback((newRange) => {
    setExperienceRange(newRange);
    const newFilters = { 
      ...filters, 
      min_experience: newRange[0] > 0 ? newRange[0] : undefined,
      max_experience: newRange[1] < 30 ? newRange[1] : undefined,
      min_fee: priceRange[0] > 0 ? priceRange[0] : undefined,
      max_fee: priceRange[1] < 5000 ? priceRange[1] : undefined,
      availability: availabilityFilter !== 'all' ? availabilityFilter : undefined,
      consultation_type: consultationType !== 'all' ? consultationType : undefined,
      gender: genderFilter !== 'all' ? genderFilter : undefined,
      page: 1 
    };
    dispatch(updateFilters({ min_experience: newRange[0] > 0 ? newRange[0] : undefined, max_experience: newRange[1] < 30 ? newRange[1] : undefined, page: 1 }));
    console.log('Experience range change:', newRange);
    dispatch(fetchDoctors(newFilters)); // Immediate search
  }, [filters, dispatch, priceRange, availabilityFilter, consultationType, genderFilter]);

  // Enhanced specialty selection handler
  const handleSpecialtyToggle = useCallback((specialty) => {
    const newSpecialties = selectedSpecialties.includes(specialty)
      ? selectedSpecialties.filter(s => s !== specialty)
      : [...selectedSpecialties, specialty];
    
    setSelectedSpecialties(newSpecialties);
    const newFilters = { 
      ...filters, 
      speciality: newSpecialties.join(','), 
      page: 1 
    };
    dispatch(updateFilters({ speciality: newSpecialties.join(','), page: 1 }));
    console.log('Specialty toggle:', newSpecialties);
    dispatch(fetchDoctors(newFilters)); // Immediate search
  }, [selectedSpecialties, filters, dispatch]);

  // Enhanced language selection handler
  const handleLanguageToggle = useCallback((language) => {
    const newLanguages = languageFilter.includes(language)
      ? languageFilter.filter(l => l !== language)
      : [...languageFilter, language];
    
    setLanguageFilter(newLanguages);
    const newFilters = { 
      ...filters, 
      language: newLanguages.join(','), 
      page: 1 
    };
    dispatch(updateFilters({ language: newLanguages.join(','), page: 1 }));
    console.log('Language toggle:', newLanguages);
    dispatch(fetchDoctors(newFilters)); // Immediate search
  }, [languageFilter, filters, dispatch]);

  const handleClearAllFilters = useCallback(() => {
    dispatch(clearFilters());
    setSelectedSpecialties([]);
    setPriceRange([0, 5000]);
    setExperienceRange([0, 30]);
    setAvailabilityFilter('all');
    setLanguageFilter([]);
    setGenderFilter('all');
    setConsultationType('all');
    setSortBy('newest');
    dispatch(fetchDoctors({ page: 1 }));
  }, [dispatch]);

  const handlePageChange = useCallback((_, newPage) => {
    dispatch(setPage(newPage));
    dispatch(fetchDoctors({ ...filters, page: newPage }));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [dispatch, filters]);

  const handleResetFilters = useCallback(() => {
    dispatch(clearFilters());
    dispatch(fetchDoctors({ page: 1 }));
    setSelectedSpecialties([]);
    setPriceRange([0, 5000]);
    setExperienceRange([0, 30]);
    setAvailabilityFilter('all');
    setLanguageFilter([]);
    setGenderFilter('all');
    setConsultationType('all');
  }, [dispatch]);

  const handleFavoriteToggle = useCallback((doctorId) => {
    setFavorites(prev => 
      prev.includes(doctorId) 
        ? prev.filter(id => id !== doctorId)
        : [...prev, doctorId]
    );
    setSnackbarMessage(
      favorites.includes(doctorId) 
        ? 'Removed from favorites' 
        : 'Added to favorites'
    );
    setSnackbarSeverity('success');
    setShowSnackbar(true);
  }, [favorites]);

  const handleDoctorSelect = useCallback((doctor) => {
    setSelectedDoctor(doctor);
    setShowDoctorModal(true);
  }, []);

  const handleBookAppointment = useCallback((doctor) => {
    navigate(`/book-appointment?doctor=${doctor.id}`);
  }, [navigate]);

  const handleViewProfile = useCallback((doctor) => {
    navigate(`/doctor/${doctor.id}`);
  }, [navigate]);

  const handleShareDoctor = useCallback((doctor) => {
    if (!doctor || !doctor.id) return;
    
    const doctorName = doctor.name || doctor.full_name || doctor.user?.name || 'Doctor';
    const url = `${window.location.origin}/doctor/${doctor.id}`;
    
    if (navigator.share) {
      navigator.share({
        title: `Dr. ${doctorName}`,
        text: `Check out Dr. ${doctorName} on PsychePoint`,
        url: url,
      }).catch((error) => {
        // User cancelled share - this is fine
        if (error.name !== 'AbortError') {
          console.error('Error sharing:', error);
        }
      });
    } else {
      // Fallback to copying to clipboard
      navigator.clipboard.writeText(url).then(() => {
        setSnackbarMessage('Link copied to clipboard');
        setSnackbarSeverity('success');
        setShowSnackbar(true);
      }).catch((error) => {
        console.error('Error copying to clipboard:', error);
        setSnackbarMessage('Failed to copy link');
        setSnackbarSeverity('error');
        setShowSnackbar(true);
      });
    }
  }, []);

  // Helper function to get icon component by name
  const getIconComponent = (iconName) => {
    const iconMap = {
      'VideoCall': VideoCall,
      'Schedule': Schedule,
      'Receipt': Receipt,
      'Support': Support,
      'Payment': Payment,
      'Folder': Folder,
      'Star': Star,
      'People': People,
      'LocationOn': LocationOn,
      'TrendingUp': TrendingUp,
      'LocalHospital': LocalHospital,
    };
    return iconMap[iconName];
  };

  // Dynamic stats from backend with better fallbacks
  const dynamicStats = [
    { 
      label: 'Active Professionals', 
      value: validStats?.active_doctors?.value || validStats?.active_doctors || '500+', 
      icon: LocalHospital, 
      color: 'primary' 
    },
    { 
      label: 'Happy Patients', 
      value: validStats?.happy_patients?.value || validStats?.happy_patients || '10K+', 
      icon: People, 
      color: 'secondary' 
    },
    { 
      label: 'Cities Covered', 
      value: validStats?.cities_covered?.value || validStats?.cities_covered || '50+', 
      icon: LocationOn, 
      color: 'success' 
    },
    { 
      label: 'Success Rate', 
      value: (() => {
        // Handle different possible formats of success rate data
        const successRate = validStats?.success_rate?.value || validStats?.success_rate;
        if (successRate === 0 || successRate === '0' || successRate === '0%') {
          return '98%'; // Fallback to a realistic value
        }
        if (typeof successRate === 'number') {
          return `${successRate}%`;
        }
        if (typeof successRate === 'string' && !successRate.includes('%')) {
          return `${successRate}%`;
        }
        return successRate || '98%';
      })(),
      icon: TrendingUp, 
      color: 'warning' 
    },
  ];

  // Dynamic specialties and languages from backend
  const dynamicSpecialties = searchOptions.specialties.length > 0 ? searchOptions.specialties : [
    'Psychiatry', 'Psychology', 'Counseling', 'Child Psychology', 
    'Marriage Counseling', 'Addiction Therapy', 'Anxiety', 'Depression',
    'Stress Management', 'Trauma Therapy', 'Eating Disorders', 'OCD',
  ];

  const dynamicLanguages = searchOptions.languages.length > 0 ? searchOptions.languages : [
    'English', 'Hindi', 'Bengali', 'Telugu', 'Marathi', 'Tamil', 'Gujarati',
    'Kannada', 'Malayalam', 'Punjabi', 'Urdu', 'Odia', 'Assamese',
  ];

  // Dynamic SEO title & description
  const title = filters?.query
    ? `${filters.query} near ${filters.location || 'you'} | PsychePoint`
    : `Find a Mental Health Professional${filters?.location ? ` in ${filters.location}` : ''}`;
  const description = filters?.query
    ? `Search results for "${filters.query}"${filters?.location ? ` in ${filters.location}` : ''}.`
    : 'Connect with top psychiatrists, psychologists, and therapists near you.';

  // JSON-LD for ItemList - safe for empty arrays
  const itemListJson = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": Array.isArray(doctors) && doctors.length > 0
      ? doctors.map((doc, index) => ({
          "@type": "ListItem",
          position: index + 1,
          url: `https://app.psychepoint.com/doctor/${doc.id || index}`
        }))
      : []
  };

  return (
    <ErrorBoundary>
      <Box>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta
          name="keywords"
          content={[
            filters?.query,
            'psychiatrist near me',
            'psychologist near me',
            filters?.location && `therapist in ${filters.location}`
          ]
            .filter(Boolean)
            .join(', ')}
        />
        <link rel="canonical" href={`https://app.psychepoint.com/${window.location.search}`} />

        {/* Open Graph */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="/images/psychepoint-og.jpg" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content="/images/psychepoint-twitter.jpg" />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(itemListJson)}
        </script>
      </Helmet>

      {/* Mobile Header */}
      {isMobile && (
        <Box sx={{ 
          position: 'sticky', 
          top: 0, 
          zIndex: 1100, 
          backgroundColor: 'background.paper',
          borderBottom: '1px solid',
          borderColor: 'divider',
          backdropFilter: 'blur(20px)',
        }}>
          <Container maxWidth="lg">
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'space-between',
              py: 2,
            }}>
              <Typography 
                variant="h6" 
                sx={{ 
                  fontWeight: 700,
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                PsychePoint
              </Typography>
              <IconButton 
                onClick={() => setShowFilters(!showFilters)}
                sx={{ 
                  backgroundColor: 'primary.main',
                  color: 'white',
                  '&:hover': { backgroundColor: 'primary.dark' }
                }}
              >
                <FilterList />
              </IconButton>
            </Box>
          </Container>
        </Box>
      )}

      {/* Hero Section */}
      <StyledHeroSection>
        <Container maxWidth="lg">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Typography
              variant="h1"
              component="h1"
              gutterBottom
              sx={{
                fontWeight: 900,
                textShadow: '0 4px 12px rgba(0,0,0,0.15)',
                mb: 3,
                fontSize: { xs: '2.25rem', sm: '3rem', md: '3.75rem', lg: '4.5rem' },
                lineHeight: { xs: 1.1, md: 1.2 },
                letterSpacing: { xs: '-0.02em', md: '-0.03em' },
                textAlign: { xs: 'center', md: 'left' },
              }}
            >
              Find Your Mental Health
              <br />
              <Box 
                component="span" 
                sx={{ 
                  color: 'secondary.main',
                  background: 'linear-gradient(135deg, #FF6B6B, #4ECDC4)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                Professional
              </Box>
            </Typography>
            
            <Typography
              variant="h5"
              sx={{
                mb: 4,
                opacity: 0.95,
                maxWidth: '700px',
                lineHeight: 1.7,
                fontWeight: 400,
                fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.5rem' },
                textAlign: { xs: 'center', md: 'left' },
                textShadow: '0 2px 4px rgba(0,0,0,0.1)',
              }}
            >
              Connect with top psychiatrists, psychologists, and therapists.
              <br />
              Book appointments easily and start your journey to better mental health.
            </Typography>

            {/* Enhanced Search */}
            <StyledSearchBox>
              <Grid container spacing={{ xs: 2, md: 3 }}>
                <Grid item xs={12} md={5}>
                  <Autocomplete
                    freeSolo
                    options={recentSearches.map(s => s.query)}
                    value={filters?.query || ''}
                    onChange={(_, newValue) => handleSearchChange('query', newValue || '')}
                    onInputChange={(_, newInputValue) => handleSearchChange('query', newInputValue)}
                    loading={loading}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={isMobile ? "Search doctors..." : "Search for doctors, specialties, or conditions..."}
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <InputAdornment position="start">
                              {loading ? (
                                <CircularProgress size={20} color="primary" />
                              ) : (
                                <Search sx={{ color: 'primary.main' }} />
                              )}
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              {filters?.query && (
                                <IconButton
                                  size="small"
                                  onClick={() => handleSearchChange('query', '')}
                                  sx={{ mr: -1 }}
                                  aria-label="Clear search"
                                >
                                  <Clear fontSize="small" />
                                </IconButton>
                              )}
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 3,
                            backgroundColor: 'background.paper',
                            height: { xs: 56, md: 64 },
                            fontSize: { xs: '0.95rem', md: '1.1rem' },
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            '&:hover': {
                              backgroundColor: alpha(theme.palette.primary.main, 0.02),
                              transform: 'translateY(-1px)',
                            },
                            '&.Mui-focused': {
                              backgroundColor: 'background.paper',
                              boxShadow: `0 0 0 3px ${alpha(theme.palette.primary.main, 0.15)}`,
                              transform: 'translateY(-2px)',
                            },
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <Box component="li" {...props}>
                        <Search sx={{ mr: 1, fontSize: 16, color: 'text.secondary' }} />
                        {option}
                      </Box>
                    )}
                    noOptionsText={
                      filters?.query && filters.query.length >= 2 
                        ? "No matches found. Try different keywords."
                        : "Start typing to search..."
                    }
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <LocationSearch
                    value={filters?.location || ''}
                    onChange={(value) => handleSearchChange('location', value)}
                    placeholder={isMobile ? "Location..." : "Enter your location..."}
                    size="large"
                  />
                </Grid>
                
                <Grid item xs={12} md={3}>
                  <Button
                    variant="contained"
                    size="large"
                    fullWidth
                    onClick={() => {
                      if (filters?.query || filters?.location) {
                        dispatch(fetchDoctors(filters));
                      }
                    }}
                    disabled={loading}
                    aria-label="Search doctors"
                    sx={{
                      height: { xs: 56, md: 64 },
                      borderRadius: 3,
                      background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
                      fontSize: { xs: '0.95rem', md: '1.1rem' },
                      fontWeight: 600,
                      textTransform: 'none',
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        background: `linear-gradient(135deg, ${theme.palette.primary.dark}, ${theme.palette.secondary.dark})`,
                        transform: 'translateY(-2px)',
                        boxShadow: '0 12px 40px rgba(0, 0, 0, 0.2)',
                      },
                      '&:active': {
                        transform: 'translateY(0px)',
                      },
                      '&:disabled': {
                        background: theme.palette.action.disabledBackground,
                        transform: 'none',
                      },
                    }}
                  >
                    {loading ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      <>
                        <Search sx={{ mr: isMobile ? 0.5 : 1, fontSize: { xs: 18, md: 24 } }} />
                        {!isMobile && 'Search'}
                      </>
                    )}
                  </Button>
                </Grid>
              </Grid>
            </StyledSearchBox>
          </motion.div>
        </Container>
      </StyledHeroSection>

      {/* Stats Section */}
      {showStats && (
        <Container maxWidth="lg" sx={{ mb: 8 }}>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            <Box sx={{ textAlign: 'center', mb: 6 }}>
              <Typography 
                variant="h3" 
                component="h2" 
                sx={{ 
                  fontWeight: 700, 
                  mb: 2,
                  fontSize: { xs: '1.75rem', sm: '2.25rem', md: '2.5rem' },
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                Trusted by Thousands
              </Typography>
              <Typography 
                variant="h6" 
                sx={{ 
                  color: 'text.secondary',
                  maxWidth: '600px',
                  mx: 'auto',
                  fontSize: { xs: '1rem', md: '1.25rem' },
                }}
              >
                Join our growing community of patients and healthcare professionals
              </Typography>
            </Box>
            <Grid container spacing={{ xs: 2, md: 3 }}>
              {dynamicStats.map((stat, index) => (
                <Grid item xs={6} md={3} key={stat.label}>
                  <motion.div
                    initial={{ opacity: 0, y: 20, scale: 0.9 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    transition={{ 
                      duration: 0.6, 
                      delay: 0.4 + index * 0.1,
                      type: "spring",
                      stiffness: 100
                    }}
                    whileHover={{ 
                      scale: 1.05,
                      transition: { duration: 0.2 }
                    }}
                  >
                    <StyledStatsCard>
                      <CardContent sx={{ textAlign: 'center', py: { xs: 2, md: 3 } }}>
                        <Box sx={{ mb: 2 }}>
                          <stat.icon 
                            sx={{ 
                              fontSize: { xs: 32, md: 40 }, 
                              color: `${stat.color}.main`,
                              mb: 1,
                              filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
                            }} 
                          />
                        </Box>
                        <Typography 
                          variant="h4" 
                          component="div" 
                          sx={{ 
                            fontWeight: 800, 
                            mb: 1,
                            fontSize: { xs: '1.5rem', md: '2rem' },
                            background: `linear-gradient(135deg, ${theme.palette[stat.color].main}, ${theme.palette[stat.color].dark})`,
                            backgroundClip: 'text',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                          }}
                        >
                          {stat.value}
                        </Typography>
                        <Typography 
                          variant="body2" 
                          color="text.secondary"
                          sx={{ 
                            fontSize: { xs: '0.875rem', md: '1rem' },
                            fontWeight: 500,
                          }}
                        >
                          {stat.label}
                        </Typography>
                      </CardContent>
                    </StyledStatsCard>
                  </motion.div>
                </Grid>
              ))}
            </Grid>
          </motion.div>
        </Container>
      )}

      {/* Main Content */}
      <Container maxWidth="lg" sx={{ mb: 8 }}>
        {(error || homepageError) && (
          <Alert severity="error" sx={{ mb: 3, borderRadius: 2 }}>
            {error || homepageError}
          </Alert>
        )}

        <Grid container spacing={{ xs: 2, md: 4 }}>
          {/* Enhanced Filters */}
          <Grid item xs={12} md={3}>
            <Box sx={{ 
              position: { xs: 'static', md: 'sticky' },
              top: { md: 24 },
              zIndex: 1,
              maxHeight: { md: 'calc(100vh - 48px)' },
              overflowY: { md: 'auto' },
              '&::-webkit-scrollbar': {
                width: '8px',
              },
              '&::-webkit-scrollbar-track': {
                background: 'transparent',
              },
              '&::-webkit-scrollbar-thumb': {
                background: theme.palette.divider,
                borderRadius: '4px',
                '&:hover': {
                  background: theme.palette.action.hover,
                },
              },
            }}>
              <FilterPanel
                filters={filters || {}}
                onChange={handleSearchChange}
                isMobile={isMobile}
                isOpen={showFilters}
                onClose={() => setShowFilters(false)}
                selectedSpecialties={selectedSpecialties}
                setSelectedSpecialties={setSelectedSpecialties}
                priceRange={priceRange}
                setPriceRange={handlePriceRangeChange}
                experienceRange={experienceRange}
                setExperienceRange={handleExperienceRangeChange}
                availabilityFilter={availabilityFilter}
                setAvailabilityFilter={handleAvailabilityChange}
                languageFilter={languageFilter}
                setLanguageFilter={setLanguageFilter}
                genderFilter={genderFilter}
                setGenderFilter={handleGenderChange}
                consultationType={consultationType}
                setConsultationType={handleConsultationTypeChange}
                showAdvancedFilters={showAdvancedFilters}
                setShowAdvancedFilters={setShowAdvancedFilters}
                specialties={dynamicSpecialties}
                languages={dynamicLanguages}
                onFilterChange={handleFilterChange}
              />
            </Box>
          </Grid>

          {/* Results */}
          <Grid item xs={12} md={9}>


            {/* Results Header */}
            <Box sx={{ 
              display: 'flex', 
              flexDirection: { xs: 'column', sm: 'row' },
              justifyContent: 'space-between', 
              alignItems: { xs: 'stretch', sm: 'center' }, 
              mb: 4,
              gap: { xs: 2, sm: 0 }
            }}>
              <Box>
                <Typography 
                  variant="h4" 
                  sx={{ 
                    fontWeight: 700, 
                    mb: 1,
                    fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}
                  aria-live="polite"
                  aria-atomic="true"
                >
                  {loading && displayDoctors.length === 0 ? (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <CircularProgress size={24} sx={{ mr: 1 }} />
                      Searching...
                    </Box>
                  ) : (
                    <>
                      {displayCount.toLocaleString()} {displayCount === 1 ? 'professional' : 'professionals'} found
                    </>
                  )}
                </Typography>
                {filters?.query && (
                  <Typography 
                    variant="body1" 
                    color="text.secondary"
                    sx={{ 
                      fontSize: { xs: '0.875rem', md: '1rem' },
                      fontWeight: 500,
                    }}
                  >
                    Results for "{filters.query}"
                    {filters?.location && ` in ${filters.location}`}
                  </Typography>
                )}
              </Box>
                
              <Box sx={{ 
                display: 'flex', 
                gap: 2, 
                alignItems: 'center',
                flexWrap: 'wrap',
                justifyContent: { xs: 'center', sm: 'flex-end' }
              }}>
                <ToggleButtonGroup
                  value={viewMode}
                  exclusive
                  onChange={(_, newMode) => newMode && setViewMode(newMode)}
                  size="small"
                  aria-label="view mode"
                  sx={{
                    '& .MuiToggleButton-root': {
                      borderRadius: 2,
                      px: 2,
                      py: 1,
                      '&.Mui-selected': {
                        backgroundColor: theme.palette.primary.main,
                        color: 'white',
                        '&:hover': {
                          backgroundColor: theme.palette.primary.dark,
                        },
                      },
                    },
                  }}
                >
                  <ToggleButton value="grid" aria-label="grid view">
                    <Tooltip title="Grid View">
                      <GridView />
                    </Tooltip>
                  </ToggleButton>
                  <ToggleButton value="list" aria-label="list view">
                    <Tooltip title="List View">
                      <ViewList />
                    </Tooltip>
                  </ToggleButton>
                </ToggleButtonGroup>

                <FormControl size="small" sx={{ minWidth: { xs: 120, sm: 140 } }}>
                  <InputLabel id="sort-select-label">Sort By</InputLabel>
                  <Select
                    labelId="sort-select-label"
                    id="sort-select"
                    value={sortBy}
                    label="Sort By"
                    onChange={(e) => {
                      setSortBy(e.target.value);
                      handleFilterChange('sortBy', e.target.value);
                    }}
                    disabled={loading}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        fontWeight: 500,
                      },
                    }}
                  >
                    <MenuItem value="newest">Newest First</MenuItem>
                    <MenuItem value="rating">Highest Rated</MenuItem>
                    <MenuItem value="experience">Most Experience</MenuItem>
                    <MenuItem value="fee">Price: Low to High</MenuItem>
                    <MenuItem value="name">Name (A-Z)</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Box>

            <DoctorsList
              doctors={displayDoctors}
              count={displayCount}
              loading={loading}
              error={error}
              viewMode={viewMode}
              filters={filters}
              onRefresh={forceRefresh}
              onClearFilters={handleClearAllFilters}
              onFavoriteToggle={handleFavoriteToggle}
              onSelect={handleDoctorSelect}
              onBookAppointment={handleBookAppointment}
              onViewProfile={handleViewProfile}
              onShare={handleShareDoctor}
              favorites={favorites}
            />

            {displayCount > 10 && !loading && (
              <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center', 
                mt: 6,
                gap: 2
              }}>
                <Pagination
                  count={Math.ceil(displayCount / 10)}
                  page={filters?.page || 1}
                  onChange={handlePageChange}
                  color="primary"
                  size={isMobile ? "medium" : "large"}
                  showFirstButton
                  showLastButton
                  sx={{
                    '& .MuiPaginationItem-root': {
                      borderRadius: 1,
                      fontSize: { xs: '0.875rem', sm: '1rem' },
                      '&.Mui-selected': {
                        backgroundColor: theme.palette.primary.main,
                        color: 'white',
                        '&:hover': {
                          backgroundColor: theme.palette.primary.dark,
                        },
                      },
                    },
                  }}
                  aria-label="pagination navigation"
                />
                <Typography variant="body2" color="text.secondary">
                  Showing page {filters?.page || 1} of {Math.ceil(displayCount / 10)}
                </Typography>
              </Box>
            )}
          </Grid>
        </Grid>
      </Container>

      {/* Features Section */}
      {showFeatures && (
        <Container maxWidth="lg" sx={{ my: 10 }}>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Box sx={{ textAlign: 'center', mb: 8 }}>
              <Typography 
                variant="h3" 
                component="h2" 
                sx={{ 
                  fontWeight: 700, 
                  mb: 3,
                  fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                {configuration.find(c => c.section_type === 'features')?.title || 'Why Choose PsychePoint?'}
              </Typography>
              <Typography 
                variant="h6" 
                sx={{ 
                  textAlign: 'center', 
                  mb: 6, 
                  color: 'text.secondary',
                  maxWidth: '800px',
                  mx: 'auto',
                  fontSize: { xs: '1rem', md: '1.25rem' },
                  lineHeight: 1.6,
                }}
              >
                {configuration.find(c => c.section_type === 'features')?.subtitle || 'Experience the difference with our comprehensive mental health platform'}
              </Typography>
            </Box>
            <Grid container spacing={{ xs: 3, md: 4 }}>
              {features.map((feature, index) => (
                <Grid item xs={12} sm={6} md={4} key={feature.id}>
                  <motion.div
                    initial={{ opacity: 0, y: 20, scale: 0.9 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    transition={{ 
                      duration: 0.6, 
                      delay: index * 0.1,
                      type: "spring",
                      stiffness: 100
                    }}
                    whileHover={{ 
                      scale: 1.03,
                      transition: { duration: 0.2 }
                    }}
                  >
                    <StyledFeatureCard>
                      <CardContent sx={{ textAlign: 'center', py: { xs: 3, md: 4 } }}>
                        <Box sx={{ mb: 3 }}>
                          {/* Dynamic icon rendering based on icon_name */}
                          {(() => {
                            const IconComponent = getIconComponent(feature.icon_name);
                            return IconComponent ? (
                              <IconComponent 
                                sx={{ 
                                  fontSize: { xs: 48, md: 60 }, 
                                  color: `${feature.color}.main`,
                                  mb: 2,
                                  filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
                                }} 
                              />
                            ) : (
                              <Star sx={{ 
                                fontSize: { xs: 48, md: 60 }, 
                                color: `${feature.color}.main`,
                                mb: 2,
                                filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
                              }} />
                            );
                          })()}
                        </Box>
                        <Typography 
                          variant="h6" 
                          component="h3" 
                          sx={{ 
                            mb: 2, 
                            fontWeight: 600,
                            fontSize: { xs: '1.1rem', md: '1.25rem' },
                          }}
                        >
                          {feature.title}
                        </Typography>
                        <Typography 
                          variant="body2" 
                          color="text.secondary"
                          sx={{ 
                            fontSize: { xs: '0.875rem', md: '1rem' },
                            lineHeight: 1.6,
                          }}
                        >
                          {feature.description}
                        </Typography>
                      </CardContent>
                    </StyledFeatureCard>
                  </motion.div>
                </Grid>
              ))}
            </Grid>
          </motion.div>
        </Container>
      )}

      {/* Testimonials Section */}
      {showTestimonials && (
        <Container maxWidth="lg" sx={{ my: 10 }}>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Box sx={{ textAlign: 'center', mb: 8 }}>
              <Typography 
                variant="h3" 
                component="h2" 
                sx={{ 
                  fontWeight: 700, 
                  mb: 3,
                  fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                {configuration.find(c => c.section_type === 'testimonials')?.title || 'What Our Users Say'}
              </Typography>
              <Typography 
                variant="h6" 
                sx={{ 
                  textAlign: 'center', 
                  mb: 6, 
                  color: 'text.secondary',
                  maxWidth: '800px',
                  mx: 'auto',
                  fontSize: { xs: '1rem', md: '1.25rem' },
                  lineHeight: 1.6,
                }}
              >
                {configuration.find(c => c.section_type === 'testimonials')?.subtitle || 'Real stories from patients and doctors'}
              </Typography>
            </Box>
            <Grid container spacing={{ xs: 3, md: 4 }}>
              {testimonials.map((testimonial, index) => (
                <Grid item xs={12} md={4} key={testimonial.id}>
                  <motion.div
                    initial={{ opacity: 0, y: 20, scale: 0.9 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    transition={{ 
                      duration: 0.6, 
                      delay: index * 0.1,
                      type: "spring",
                      stiffness: 100
                    }}
                    whileHover={{ 
                      scale: 1.03,
                      transition: { duration: 0.2 }
                    }}
                  >
                    <StyledTestimonialCard>
                      <CardContent sx={{ py: { xs: 3, md: 4 } }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                          <Avatar 
                            src={testimonial.avatar} 
                            sx={{ 
                              width: { xs: 48, md: 56 }, 
                              height: { xs: 48, md: 56 }, 
                              mr: 2,
                              boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                            }}
                          />
                          <Box>
                            <Typography 
                              variant="h6" 
                              sx={{ 
                                fontWeight: 600,
                                fontSize: { xs: '1rem', md: '1.25rem' },
                              }}
                            >
                              {testimonial.name}
                            </Typography>
                            <Typography 
                              variant="body2" 
                              color="text.secondary"
                              sx={{ 
                                fontSize: { xs: '0.875rem', md: '1rem' },
                              }}
                            >
                              {testimonial.role} • {testimonial.location}
                            </Typography>
                          </Box>
                        </Box>
                        <Rating 
                          value={testimonial.rating} 
                          readOnly 
                          sx={{ mb: 2 }}
                          size={isMobile ? "small" : "medium"}
                        />
                        <Typography 
                          variant="body1" 
                          sx={{ 
                            fontStyle: 'italic', 
                            mb: 3,
                            fontSize: { xs: '0.875rem', md: '1rem' },
                            lineHeight: 1.6,
                            color: 'text.primary',
                          }}
                        >
                          "{testimonial.text}"
                        </Typography>
                        <Chip 
                          label={testimonial.condition_or_specialty} 
                          size="small" 
                          color="primary" 
                          variant="outlined"
                          sx={{ 
                            fontSize: { xs: '0.75rem', md: '0.875rem' },
                          }}
                        />
                      </CardContent>
                    </StyledTestimonialCard>
                  </motion.div>
                </Grid>
              ))}
            </Grid>
          </motion.div>
        </Container>
      )}

      {/* Mobile Filter Toggle Button */}
      {isMobile && (
        <StyledFloatingActionButton
          color="primary"
          aria-label="Toggle Filters"
          onClick={() => setShowFilters(!showFilters)}
          sx={{
            bottom: theme.spacing(10),
            background: `linear-gradient(135deg, ${theme.palette.secondary.main}, ${theme.palette.primary.main})`,
            '&:hover': {
              background: `linear-gradient(135deg, ${theme.palette.secondary.dark}, ${theme.palette.primary.dark})`,
            },
          }}
        >
          <FilterList />
        </StyledFloatingActionButton>
      )}

      {/* Floating Action Button */}
      <StyledFloatingActionButton
        color="primary"
        aria-label="Quick Actions"
        onClick={() => setShowSnackbar(true)}
      >
        <SpeedDialIcon />
      </StyledFloatingActionButton>

      {/* Call to Action Section */}
      <Box sx={{ 
        background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, ${alpha(theme.palette.secondary.main, 0.05)} 100%)`,
        py: 8,
        mt: 8,
      }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center' }}>
            <Typography 
              variant="h3" 
              sx={{ 
                fontWeight: 700, 
                mb: 3,
                fontSize: { xs: '1.75rem', sm: '2.25rem', md: '2.5rem' },
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Ready to Start Your Journey?
            </Typography>
            <Typography 
              variant="h6" 
              sx={{ 
                color: 'text.secondary',
                mb: 4,
                maxWidth: '600px',
                mx: 'auto',
                fontSize: { xs: '1rem', md: '1.25rem' },
                lineHeight: 1.6,
              }}
            >
              Connect with a mental health professional today and take the first step towards better mental well-being.
            </Typography>
            <Button
              variant="contained"
              size="large"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              sx={{
                background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                px: 4,
                py: 2,
                fontSize: { xs: '1rem', md: '1.25rem' },
                fontWeight: 600,
                textTransform: 'none',
                borderRadius: 3,
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
                '&:hover': {
                  background: `linear-gradient(135deg, ${theme.palette.primary.dark}, ${theme.palette.secondary.dark})`,
                  transform: 'translateY(-2px)',
                  boxShadow: '0 12px 40px rgba(0, 0, 0, 0.2)',
                },
              }}
            >
              Book A Professional Now
            </Button>
          </Box>
        </Container>
      </Box>

      {/* Snackbar for notifications */}
      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => setShowSnackbar(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert 
          onClose={() => setShowSnackbar(false)} 
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {/* Doctor Detail Modal */}
      <Dialog
        open={showDoctorModal}
        onClose={() => setShowDoctorModal(false)}
        maxWidth="md"
        fullWidth
      >
        {selectedDoctor && (
          <>
            <DialogTitle>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6">Dr. {selectedDoctor.name}</Typography>
                <IconButton onClick={() => setShowDoctorModal(false)}>
                  <Close />
                </IconButton>
              </Box>
            </DialogTitle>
            <DialogContent>
              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <Avatar
                    src={selectedDoctor.avatar}
                    sx={{ width: 120, height: 120, mx: 'auto', mb: 2 }}
                  />
                  <Typography variant="h6" sx={{ textAlign: 'center', mb: 1 }}>
                    Dr. {selectedDoctor.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mb: 2 }}>
                    {selectedDoctor.specialty}
                  </Typography>
                  <Rating value={selectedDoctor.rating} readOnly sx={{ display: 'flex', justifyContent: 'center' }} />
                </Grid>
                <Grid item xs={12} md={8}>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    {selectedDoctor.bio}
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
                    {selectedDoctor.specialties?.map((specialty) => (
                      <Chip key={specialty} label={specialty} size="small" />
                    ))}
                  </Box>
                  <Typography variant="body2" color="text.secondary">
                    Experience: {selectedDoctor.experience} years
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Consultation Fee: ₹{selectedDoctor.consultationFee}
                  </Typography>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setShowDoctorModal(false)}>Close</Button>
                    <Button
                      variant="contained"
                      onClick={() => {
                        handleBookAppointment(selectedDoctor);
                        setShowDoctorModal(false);
                      }}
                    >
                      Book Appointment
                    </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
      </Box>
    </ErrorBoundary>
  );
};

export default HomePage;
